export default function DressroomBrandSection() {
  return (
    <section className="mt-20 border-t border-gray-100 pt-16">
      {/* Brand Header */}
      <div className="text-center mb-14">
        <span className="inline-block text-[11px] font-bold tracking-[0.3em] uppercase px-4 py-1.5 rounded-full mb-6" style={{ backgroundColor: '#F0EAE0', color: '#8C7D6E' }}>
          Brand Story
        </span>
        {/* 실제 W.DRESSROOM 로고 */}
        <div className="flex items-center justify-center mb-4">
          <img
            src="https://wdressroom.co.kr/web/upload/category/editor/2026/02/27/9f8b74b94133ad8e4b47fc858f217442.png"
            alt="W.DRESSROOM 로고"
            className="h-10 object-contain"
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = 'none';
              const fallback = document.getElementById('dressroom-logo-fallback');
              if (fallback) fallback.style.display = 'block';
            }}
          />
          <h2 id="dressroom-logo-fallback" className="text-3xl md:text-4xl font-black text-gray-900 tracking-tight hidden">W.DRESSROOM</h2>
        </div>
        <p className="text-lg text-gray-400 tracking-widest font-medium">衣橱 / 드레스룸</p>
        <p className="mt-4 text-[14px] text-gray-500 leading-relaxed max-w-2xl mx-auto">
          用香气填满日常的生活方式香氛品牌 · 일상을 향기로 채우는 라이프스타일 프래그런스 브랜드
        </p>
      </div>

      {/* Hero Banner */}
      <div className="rounded-3xl overflow-hidden mb-12" style={{ background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)' }}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
          <div className="p-10 lg:p-14 flex flex-col justify-center">
            <span className="inline-block text-[10px] font-bold tracking-[0.3em] uppercase px-3 py-1 rounded-full mb-6 w-fit" style={{ backgroundColor: 'rgba(255,255,255,0.1)', color: '#D4C9B8' }}>
              Fabric Perfume
            </span>
            <h3 className="text-3xl md:text-4xl font-black text-white leading-tight mb-4 tracking-tight">
              衣物香水的<br />
              <span className="text-2xl font-bold" style={{ color: '#C8B89A' }}>全新标准</span>
            </h3>
            <p className="text-[13px] leading-relaxed mb-2" style={{ color: '#A09080' }}>섬유향수의 새로운 기준 / New Standard of Fabric Perfume</p>
            <p className="text-[14px] text-gray-300 leading-relaxed mt-4">
              超越喷洒在衣物上的香水，提出为日常所有织物增添香气的全新生活方式。
            </p>
            <p className="text-[13px] leading-relaxed mt-2" style={{ color: '#7A6A5A' }}>
              옷에 뿌리는 향수를 넘어, 일상의 모든 섬유에 향기를 더하는 새로운 라이프스타일을 제안합니다.
            </p>
            <div className="flex flex-wrap gap-2 mt-6">
              {[
                { zh: '衣物', ko: '의류' },
                { zh: '床品', ko: '침구' },
                { zh: '窗帘', ko: '커튼' },
                { zh: '地毯', ko: '카펫' },
                { zh: '空间香氛', ko: '공간향수' },
              ].map((tag) => (
                <span key={tag.zh} className="text-[11px] px-3 py-1 rounded-full font-medium" style={{ backgroundColor: 'rgba(200,184,154,0.15)', color: '#C8B89A', border: '1px solid rgba(200,184,154,0.2)' }}>
                  {tag.zh} <span style={{ opacity: 0.6 }}>/ {tag.ko}</span>
                </span>
              ))}
            </div>
          </div>
          <div className="p-10 lg:p-14 flex flex-col justify-center gap-5" style={{ borderLeft: '1px solid rgba(255,255,255,0.06)' }}>
            {[
              { num: '01', titleZh: '40+标志性香气', titleKo: '40+ 시그니처 향', descZh: '花香、麝香、木香、柑橘等40种以上多样香气阵容', descKo: '플로럴, 머스크, 우드, 시트러스 등 40가지 이상의 다양한 향 라인업' },
              { num: '02', titleZh: '织物友好配方', titleKo: '섬유 친화 포뮬러', descZh: '不损伤织物只留香气的特殊配方，保护衣物', descKo: '섬유 손상 없이 향기만 남기는 특수 포뮬러로 옷감을 보호' },
              { num: '03', titleZh: '持久留香', titleKo: '오래 지속되는 향', descZh: '专为在织物上比普通香水更持久留香而设计的专用配方', descKo: '일반 향수보다 섬유에 오래 지속되도록 설계된 전용 포뮬러' },
            ].map((item) => (
              <div key={item.num} className="flex gap-4">
                <span className="text-[11px] font-black shrink-0 mt-0.5" style={{ color: '#C8B89A' }}>{item.num}</span>
                <div>
                  <p className="text-[13px] font-bold text-white mb-0.5">{item.titleZh}</p>
                  <p className="text-[11px] mb-1.5" style={{ color: '#7A6A5A' }}>{item.titleKo}</p>
                  <p className="text-[12px] leading-relaxed" style={{ color: '#8A7A6A' }}>{item.descZh}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scent Lines */}
      <div className="mb-12">
        <h4 className="text-[11px] font-bold tracking-[0.25em] uppercase text-center mb-6" style={{ color: '#8C7D6E' }}>Scent Lines · 향 라인업</h4>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {[
            { icon: 'ri-flower-line', name: 'Floral', nameZh: '花香系', nameKo: '플로럴', desc: '玫瑰、牡丹、花开日等', descKo: '로즈, 피오니, 블루밍데이 등', color: '#F5E6E8' },
            { icon: 'ri-leaf-line', name: 'Fresh', nameZh: '清新系', nameKo: '프레시', desc: '柑橘、水感、绿叶等', descKo: '시트러스, 아쿠아, 그린 등', color: '#E6F0E8' },
            { icon: 'ri-tree-line', name: 'Woody', nameZh: '木香系', nameKo: '우디', desc: '仙女木、黑麝香等', descKo: '페어리우드, 블랙머스크 등', color: '#EDE6DC' },
            { icon: 'ri-heart-line', name: 'Soft', nameZh: '柔和系', nameKo: '소프트', desc: '白麝香、棉花、婴儿爽身粉等', descKo: '화이트머스크, 코튼, 베이비파우더 등', color: '#EAE6F0' },
          ].map((line) => (
            <div key={line.name} className="rounded-2xl p-5 text-center" style={{ backgroundColor: line.color, border: '1px solid rgba(0,0,0,0.05)' }}>
              <div className="w-10 h-10 flex items-center justify-center rounded-xl mx-auto mb-3 bg-white/60">
                <i className={`${line.icon} text-lg text-gray-600`}></i>
              </div>
              <p className="text-[13px] font-black text-gray-800">{line.name}</p>
              <p className="text-[11px] font-semibold text-gray-600 mb-1">{line.nameZh} / {line.nameKo}</p>
              <p className="text-[11px] text-gray-700 leading-relaxed">{line.desc}</p>
              <p className="text-[10px] text-gray-400 leading-relaxed mt-0.5">{line.descKo}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Brand Values */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
        {[
          { icon: 'ri-award-line', titleZh: '国内衣物香水第一', titleKo: '국내 섬유향수 1위', descZh: '韩国衣物香水市场占有率第一品牌', descKo: '대한민국 섬유향수 시장 점유율 1위 브랜드' },
          { icon: 'ri-global-line', titleZh: '全球出口', titleKo: '글로벌 수출', descZh: '出口中国·日本·东南亚等全球品牌', descKo: '중국·일본·동남아 등 전 세계 수출 브랜드' },
          { icon: 'ri-leaf-line', titleZh: '织物安全成分', titleKo: '섬유 안전 성분', descZh: '由不损伤织物的安全成分组成', descKo: '섬유 손상 없는 안전한 성분으로 구성' },
          { icon: 'ri-palette-line', titleZh: '40+香气阵容', titleKo: '40+ 향 라인업', descZh: '满足多样喜好的40种以上香气', descKo: '다양한 취향을 만족시키는 40가지 이상의 향' },
        ].map((item) => (
          <div key={item.titleZh} className="rounded-2xl p-6 text-center" style={{ backgroundColor: '#FAFAF8', border: '1px solid #EDE8E0' }}>
            <div className="w-12 h-12 flex items-center justify-center rounded-2xl mx-auto mb-4" style={{ backgroundColor: '#F0EAE0' }}>
              <i className={`${item.icon} text-xl`} style={{ color: '#5C4F42' }}></i>
            </div>
            <p className="text-[13px] font-bold text-gray-800 mb-0.5">{item.titleZh}</p>
            <p className="text-[11px] mb-2" style={{ color: '#8C7D6E' }}>{item.titleKo}</p>
            <p className="text-[12px] text-gray-500 leading-relaxed">{item.descZh}</p>
          </div>
        ))}
      </div>

      {/* How to Use */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
        <div className="rounded-2xl p-8" style={{ backgroundColor: '#F7F4F0', border: '1px solid #EDE8E0' }}>
          <h4 className="text-[11px] font-bold tracking-[0.25em] uppercase mb-5" style={{ color: '#8C7D6E' }}>How to Use · 사용 방법</h4>
          <div className="space-y-4">
            {[
              { step: '01', zh: '距衣物20~30cm处喷洒', ko: '의류에서 20~30cm 거리를 두고 분사' },
              { step: '02', zh: '均匀喷洒在床品·窗帘上后自然晾干', ko: '침구·커튼에 골고루 분사 후 자연 건조' },
              { step: '03', zh: '作为空间香水使用时向空中喷洒', ko: '공간 향수로 활용 시 공중에 분사' },
              { step: '04', zh: '避免直射阳光，存放在阴凉处', ko: '직사광선 피해 서늘한 곳에 보관' },
            ].map((item) => (
              <div key={item.step} className="flex items-start gap-3">
                <span className="text-[11px] font-black shrink-0 w-6 h-6 flex items-center justify-center rounded-full" style={{ backgroundColor: '#2E5240', color: '#fff' }}>{item.step}</span>
                <div>
                  <p className="text-[13px] font-medium text-gray-700">{item.zh}</p>
                  <p className="text-[11px]" style={{ color: '#8C7D6E' }}>{item.ko}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="rounded-2xl p-8" style={{ backgroundColor: '#F7F4F0', border: '1px solid #EDE8E0' }}>
          <h4 className="text-[11px] font-bold tracking-[0.25em] uppercase mb-5" style={{ color: '#8C7D6E' }}>B2B应用领域 · B2B 활용 분야</h4>
          <div className="space-y-3">
            {[
              { zh: '酒店·度假村客房床品及毛巾香气管理', ko: '호텔·리조트 객실 침구 및 수건 향기 관리' },
              { zh: '洗衣店·干洗店收尾香气处理', ko: '세탁소·드라이클리닝 업체 마무리 향기' },
              { zh: '服装店试衣间及店铺空间香气', ko: '의류 매장 피팅룸 및 매장 공간 향기' },
              { zh: '美容·水疗机构毛巾及浴袍香气', ko: '뷰티·스파 업체 타월 및 가운 향기' },
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center rounded-full shrink-0 mt-0.5" style={{ backgroundColor: '#2E5240' }}>
                  <i className="ri-check-line text-white text-[10px]"></i>
                </div>
                <div>
                  <p className="text-[13px] font-medium text-gray-700">{item.zh}</p>
                  <p className="text-[11px]" style={{ color: '#8C7D6E' }}>{item.ko}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Awards */}
      <div className="rounded-2xl p-8" style={{ backgroundColor: '#1a1a1a' }}>
        <h4 className="text-[11px] font-bold tracking-[0.25em] uppercase mb-6 text-center" style={{ color: '#8C7D6E' }}>Awards &amp; Recognition · 수상 및 인정</h4>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {[
            { icon: 'ri-award-fill', titleZh: '衣物香水销量第一', titleKo: '섬유향수 판매 1위', year: '2024' },
            { icon: 'ri-medal-line', titleZh: '消费者满意大奖', titleKo: '소비자 만족 대상', year: '2023' },
            { icon: 'ri-global-line', titleZh: '出口优秀品牌', titleKo: '수출 우수 브랜드', year: '2023' },
            { icon: 'ri-star-line', titleZh: 'Olive Young最佳', titleKo: '올리브영 베스트', year: '2024' },
          ].map((item) => (
            <div key={item.titleZh} className="text-center p-4 rounded-xl" style={{ backgroundColor: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)' }}>
              <div className="w-10 h-10 flex items-center justify-center rounded-xl mx-auto mb-3" style={{ backgroundColor: 'rgba(200,184,154,0.15)' }}>
                <i className={`${item.icon} text-lg`} style={{ color: '#C8B89A' }}></i>
              </div>
              <p className="text-[12px] font-bold text-white mb-0.5">{item.titleZh}</p>
              <p className="text-[10px] mb-1" style={{ color: '#5A4A3A' }}>{item.titleKo}</p>
              <span className="text-[10px] font-bold px-2 py-0.5 rounded-full" style={{ backgroundColor: 'rgba(200,184,154,0.1)', color: '#C8B89A' }}>{item.year}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
